import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  jobs: [],
  slots: [],
  jobsByUser: [],
  pendingInvoices: [],
  invoiceData: null,
  jobData: null,
  error: null
};


export const JOB_URL = "/admin/job";

export const getJobs = createAsyncThunk(
  JOB_URL + "/get",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(JOB_URL, {
        params: formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getJobById = createAsyncThunk(
  JOB_URL + "/get-by-id",
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(`${JOB_URL}/view/${id}`);
      if (response.data) {
        return response.data?.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const createJob = createAsyncThunk(
  JOB_URL + "/create",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(JOB_URL, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.msg || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || "Error"
      );
    }
  }
);

export const updateJobStatus = createAsyncThunk(
  JOB_URL + "/status",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(JOB_URL + "/status", formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const jobupdated = createAsyncThunk(
  JOB_URL + "/update",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      // Axios automatically handles FormData and sets Content-Type with boundary
      const response = await axiosInstance.post(JOB_URL + "/update", formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.error('Job update API error:', error);
      console.error('Error response:', error.response?.data);
      return rejectWithValue(
        error.response?.data?.message || error.response?.data?.error || error.message || "Error updating job"
      );
    }
  }
);

export const getSlotAvailability = createAsyncThunk(
  "api/user/job/get/slot/availibilty",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get("user/job/get/slot/availibilty", {
        params: formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const updateJobStep = createAsyncThunk(
  JOB_URL + "/job_step",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(JOB_URL + "/job_step", formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getJobsByUser = createAsyncThunk(
  JOB_URL + "/get-jobs-by-user",
  async ({ id }, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(`${JOB_URL}/jobs-by-user`, {
        params: { id }
      });
      if (response.data) {
        return response.data?.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const invoiceSentToCustomer = createAsyncThunk(
  JOB_URL + "/invoice-sent-to-customer",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(`${JOB_URL}/invoice-sent-to-customer`, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getPendingInvoice = createAsyncThunk(
  JOB_URL + "/get-pending-invoice",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(`${JOB_URL}/pending-invoices`, {
        params: formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

export const invoiceStatusChange = createAsyncThunk(
  JOB_URL + "/invoice-status-update",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(`${JOB_URL}/invoice-status-update`, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const removeImageFromEditJob = createAsyncThunk(
  JOB_URL + "/remove-image-from-edit",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(`${JOB_URL}/remove-image-from-edit`, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    clearJobsByUser: (state) => {
      state.jobData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(getJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getJobById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getJobById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobData = action.payload;
      })
      .addCase(getJobById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(createJob.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobData = action.payload?.data;
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(updateJobStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateJobStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobData = action.payload?.data;
      })
      .addCase(updateJobStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(jobupdated.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(jobupdated.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobData = action.payload?.data;
      })
      .addCase(jobupdated.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getSlotAvailability.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSlotAvailability.fulfilled, (state, action) => {
        state.isLoading = false;
        state.slots = action.payload?.data;
      })
      .addCase(getSlotAvailability.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(updateJobStep.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateJobStep.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobData = action.payload?.data;
      })
      .addCase(updateJobStep.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getJobsByUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getJobsByUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobsByUser = action.payload;
      })
      .addCase(getJobsByUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(invoiceSentToCustomer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(invoiceSentToCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.invoiceData = action.payload;
      })
      .addCase(invoiceSentToCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getPendingInvoice.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPendingInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pendingInvoices = action.payload;
      })
      .addCase(getPendingInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(invoiceStatusChange.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(invoiceStatusChange.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobData = action.payload;
      })
      .addCase(invoiceStatusChange.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(removeImageFromEditJob.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(removeImageFromEditJob.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.jobData = action.payload;
      })
      .addCase(removeImageFromEditJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logout, () => initialState)
  }
})

export const formattedDateTime = (date) => {
  return date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, '0') + "-" +
    String(date.getDate()).padStart(2, '0') + " " +
    String(date.getHours()).padStart(2, '0') + ":" +
    String(date.getMinutes()).padStart(2, '0') + ":" +
    String(date.getSeconds()).padStart(2, '0');
}
export const { clearJobsByUser } = jobSlice.actions
export default jobSlice.reducer